// Canonical resource-kind taxonomy. Mirrors the `resources_kind_check`
// CHECK constraint in `apps/web/drizzle/0058`/`0059`. The integration test
// `apps/web/src/server/resources/__integration__/kind-check-invariant.test.ts`
// pins this list to the constraint so future migrations cannot drift.
export const RESOURCE_KINDS = [
    'article',
    'video',
    'toolkit',
    'workshop',
    'essay',
    'discussion_guide',
    'research',
    'podcast',
    'activity',
    'playlist',
];
//# sourceMappingURL=resource-kinds.js.map